/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=ff6b5c68"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ff6b5c68&lang=scss"

import exportComponent from "E:\\A_Project\\TC-project\\front-abroad-tms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__